/**
 * The initials an avatar shows when it has no picture, the same everywhere a
 * person is drawn without one: the transcript page, the account menu, a
 * speaker slot in a render (#566). The first letter of the first and of the
 * last word (one word, one letter), in graphemes so an emoji is kept whole; a
 * word with no letter, digit or emoji (a lone bracket) contributes none.
 */
export function initialsOf(text: string | null | undefined): string {
  const initialOf = (word: string) =>
    [...word].find((ch) => /[\p{L}\p{N}\p{Extended_Pictographic}]/u.test(ch))
  const letters = (text ?? '')
    .split(/\s+/)
    .map(initialOf)
    .filter((ch): ch is string => !!ch)
  if (!letters.length) return ''
  const picked =
    letters.length > 1 ? letters[0]! + letters.at(-1)! : letters[0]!
  return picked.toUpperCase()
}
